import styled from 'styled-components';

export const MobilePositionMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    
    .operation-button {
        flex: 1;
    }
`;

export const MobilePositionLeverageToggleStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    background: var(--color-button-secondary-default);
    border-radius: 16px;
    height: 100%;
`;

export const MobilePositionUnavailableStyled = styled.div`
    display: flex;
    flex: 1;
    gap: 8px;
    padding: 16px;
    font-size: 16px;
    font-weight: 600;

    .subtext {
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        font-weight: normal;
    }

    .time_left {
        color: var(--color-label-primary);
        opacity: 0.8;
        background-color: var(--color-fill-primary);
        padding: 0 6px;
        border-radius: 8px;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        width: fit-content;
    }
`;
